<template>
  <component :is="component" />
</template>

<script>
import productCheck from '../components/productCheck.vue'
import productEdit from '../productEdit.vue'
export default {
  components: {
    productCheck,
    productEdit
  },
  data() {
    return {
      component: 'productCheck'
    }
  },
  created() {
    const { _role } = this.$route.query
    this.component = _role === 'check' ? 'productCheck' : 'productEdit'
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/product-manage/check/productCheck.vue